var _rect, _path, _rect2, _rect3, _rect4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2926 -2916H4201V-2946H-2926V-2916ZM4188 -2929V2930H4218V-2929H4188ZM4201 2917H-2926V2947H4201V2917ZM-2913 2930V-2929H-2943V2930H-2913ZM-2926 2917C-2918.82 2917 -2913 2922.82 -2913 2930H-2943C-2943 2939.39 -2935.39 2947 -2926 2947V2917ZM4188 2930C4188 2922.82 4193.82 2917 4201 2917V2947C4210.39 2947 4218 2939.39 4218 2930H4188ZM4201 -2916C4193.82 -2916 4188 -2921.82 4188 -2929H4218C4218 -2938.39 4210.39 -2946 4201 -2946V-2916ZM-2926 -2946C-2935.39 -2946 -2943 -2938.39 -2943 -2929H-2913C-2913 -2921.82 -2918.82 -2916 -2926 -2916V-2946Z",
    fill: "#FF0000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    transform: "translate(-342 -638)",
    fill: "#17171F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 257,
    height: 52,
    transform: "translate(-12 -12)",
    fill: "#434343"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    stroke: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.9998L18.5 17.4998L17.795 16.7948L20.585 13.9998L17.795 11.2048L18.5 10.4998L22 13.9998ZM7 13.9998L10.5 10.4998L11.205 11.2048L8.415 13.9998L11.205 16.7948L10.5 17.4998L7 13.9998ZM12.71 18.7418L15.32 8.99982L16.286 9.25832L13.676 18.9998L12.71 18.7418Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeIcon);
export default __webpack_public_path__ + "static/media/code_icon.894aa3e471fe1a3a367f3bdac21ee29d.svg";
export { ForwardRef as ReactComponent };